import { render, staticRenderFns } from "./menuLog.vue?vue&type=template&id=2820c484"
import script from "./menuLog.vue?vue&type=script&lang=js"
export * from "./menuLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2820c484')) {
      api.createRecord('2820c484', component.options)
    } else {
      api.reload('2820c484', component.options)
    }
    module.hot.accept("./menuLog.vue?vue&type=template&id=2820c484", function () {
      api.rerender('2820c484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/log/menuLog.vue"
export default component.exports